import _ from 'lodash';
import moment from 'moment';
import { selectorFamily, atomFamily } from 'recoil';
import { loadChart, loadCharts, loadMetricsData } from '../../../repositories/HttpRepository';

////////////////////////////////
/// utils

export const chartGroup = selectorFamily({
  key: `chart-group`,
  get:
    (id) =>
    async ({ get }) => {
      // var s = get(bareChartGroupWithId(id))
      let resp = await loadCharts(id);
      // resp.data.forEach(d => {
      //   var [config, setConfig] = useRecoilState(chartConfigForId(d.id))
      //   setConfig(d)
      // })
      return resp.data;
    },
});

////////////////////////////////////
// Chart data

export const chartConfig = selectorFamily({
  key: 'chart-config-selector',
  get:
    (id) =>
    async ({ get }) => {
      let resp = await loadChart(id);
      return resp.data;
    },
});

export const filterForChart = atomFamily({
  key: `chart-filter`,
  default: {
    end: moment().add(5, 'day').toISOString(),
    start: moment().add(-14, 'day').toISOString(),
  },
});

export const chartData = selectorFamily({
  key: `chart-data`,
  get:
    (id) =>
    async ({ get }) => {
      let s = get(filterForChart(id));
      let resp = await loadMetricsData(id, s);
      let data = resp.data.data.map((g) => _.sortBy(g, [(v) => v.start]));
      resp.data.data = data;
      return resp.data;
    },
});

export const chartView = selectorFamily({
  key: `chart-view`,
  get:
    (id) =>
    async ({ get }) => {
      let s = get(filterForChart(id));
      let resp = await loadMetricsData(id, s);
      return resp.data;
    },
});
